import * as io from 'socket.io-client';
import { Injectable } from '@angular/core';
import { GN } from './gn';
import { DIC } from './pages/dic';
import * as moment from 'moment';
import { MapviewPage } from './pages/mapview/mapview';

declare var ol;
declare var google;

@Injectable()



export class VehicleService {

    socket: any;
    maps: any
    constructor(public gn: GN, public dic: DIC) {

    }

    reloadInitVehicles(_cb) {
        var _that = this
        // console.log(this.gn.Colors)
        this.gn._Post('/api/gn/vehiclesByRoleID/', { roleid: this.gn.user.RoleId, clientid: this.gn.user.ClientId, userid: this.gn.user.UserId, driverid: this.gn.user.driverid }, function (_data) {
            var _d = _data.data1[0].getcpforfirstws
            var arr = _d.split('#')
            var _visVeh = 0
            // console.log(_that.gn.Organisations, 'daj da vidam organizacii dali ke mi dades')
            // console.log(_data.data2, '_data.data2')
            // console.log(arr)
            for (var i = 1; i < arr.length; i++) {
                var v = _that.parseData(arr[i])
                if (!v) {
                    continue;
                }
                const vehicleIndex = _that.gn.VehiclesDic[v.vehicleid];
                const currentVehicle = _that.gn.Vehicles[vehicleIndex];
                // Refresh only initialized vehicles, as the socket stream does.
                // The response can include an unknown ID or arrive after a reset.
                if (!currentVehicle || currentVehicle.vehicleid + '' !== v.vehicleid + '') {
                    continue;
                }
                // _that.gn.VehiclesDic[v.vehicleid] = _that.gn.Vehicles.length
                for (var j = 0; j < _data.data2.length; j++) {

                    if (_data.data2[j].vehicleid + '' == v.vehicleid + '') {
                        //v.driverdest = _data.data2[j].driverdest
                        // console.log('TUKAAA')
                        // console.log(_data.data2[j])
                        // console.log(_data.data2[j].organisationid)
                        v.equipment = _data.data2[j].equipment
                        v.cancontrol = _data.data2[j].cancontrol

                        v.allowfuelpulses = _data.data2[j].allowfuelpulses
                        v.totalfuelused = _data.data2[j].totalfuelused
                        v.istank = _data.data2[j].istank
                        v.isdigalkanalogna = _data.data2[j].isdigalkanalogna
                        v.allowfuel = _data.data2[j].allowfuel
                        v.allowtacho = _data.data2[j].allowtacho
                        v.allowbeacon = _data.data2[j].allowbeacon
                        v.allowdriverfrombeacon = _data.data2[j].allowdriverfrombeacon
                        v.electric = _data.data2[j].electric
                        v.nextservicewhours = _data.data2[j].nextservicewhours
                        v.roomid = _data.data2[j].roomid
                        // console.log(v.equipment, 'v.equipment')
                        v.roaddirection = _data.data2[j].roaddirection

                        v.nopay = _data.data2[j].nopay
                        v.lastpaydt = _data.data2[j].lastpaydt == '/' ? '/' : moment(_data.data2[j].lastpaydt).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)

                        if (v.nopay == '1') {
                            v.color = 'Gray'
                            v.datumformated = v.lastpaydt
                        }

                        v.orgcolor = ''
                        v.visible = _data.data2[j].visible
                        v.organisationid = _data.data2[j].organisationid
                        v.orgname = _data.data2[j].orgname
                        v.consumptionbyhour = _data.data2[j].consumptionbyhour
                        v.brand = _data.data2[j].brand
                        v.armed = _data.data2[j].armed
                        v.multiplefueltypes = _data.data2[j].multiplefueltypes
                        //console.log('###', v.vehicleid, _data.data2[j].approve, _data.data2[j].suspend)
                        v.approve = _data.data2[j].approve
                        v.suspend = _data.data2[j].suspend

                        v.typeid = _data.data2[j].typeid
                        v.printtravelorder = _data.data2[j].printtravelorder
                        v.alias = _data.data2[j].alias
                        v.model = _data.data2[j].model
                        v.albletemp = _data.data2[j].albletemp
                        v.alrpm = _data.data2[j].alrpm
                        v.showrpm = _data.data2[j].showrpm
                        v.driver = _data.data2[j].driver
                        v.altemp = _data.data2[j].altemp
                        v.alfuel = _data.data2[j].alfuel
                        v.fuel = _data.data2[j].fuel
                        //v.ufuel = _data.data2[j].ufuel
                        v.alcanbas = _data.data2[j].alcanbas
                        v.engineworktimetype = _data.data2[j].engineworktimetype
                        // v.AllowCANbus = _data.data2[j].AllowCANbus
                        v.a_cbd = _data.data2[j].a_cbd
                        v.a_cbr = _data.data2[j].a_cbr
                        v.a_cbf = _data.data2[j].a_cbf
                        v.a_cbt = _data.data2[j].a_cbt

                        v.speedlimitalertallow = _data.data2[j].speedlimitalertallow
                        v.allowdraeger = _data.data2[j].allowdraeger

                        v.dashboard = false
                        //debugger

                        v.slot1name = _data.data2[j].slot1name
                        v.a_bletemp1 = _data.data2[j].allowbletemp1
                        v.a_blehumidity1 = _data.data2[j].allowblehumidity1
                        v.a_blebattery1 = _data.data2[j].allowblebattery1

                        v.slot2name = _data.data2[j].slot2name
                        v.a_bletemp2 = _data.data2[j].allowbletemp2
                        v.a_blehumidity2 = _data.data2[j].allowblehumidity2
                        v.a_blebattery2 = _data.data2[j].allowblebattery2

                        v.slot3name = _data.data2[j].slot3name
                        v.a_bletemp3 = _data.data2[j].allowbletemp3
                        v.a_blehumidity3 = _data.data2[j].allowblehumidity3
                        v.a_blebattery3 = _data.data2[j].allowblebattery3

                        v.slot4name = _data.data2[j].slot4name
                        v.a_bletemp4 = _data.data2[j].allowbletemp4
                        v.a_blehumidity4 = _data.data2[j].allowblehumidity4
                        v.a_blebattery4 = _data.data2[j].allowblebattery4

                        v.allowbattery = _data.data2[j].allowbattery
                        v.allowultrasonic = _data.data2[j].allowultrasonic
                        v.zonenames = _data.data2[j].zonenames
                        v.poinames = _data.data2[j].poinames
                        v.allowgarmin = _data.data2[j].allowgarmin
                        v.allowengineblock = _data.data2[j].allowengineblock

                        v.stopstatusdata = []

                        var _AllowedPKSABH = '0'
                        if (_data.data2[j].prednavrata != '-' || _data.data2[j].zadnavrata != '-' || _data.data2[j].hauba != '-' || _data.data2[j].kapaci != '-' || _data.data2[j].pumpa != '-' || _data.data2[j].sovozac != '-' || _data.data2[j].digalka != '-' || _data.data2[j].allowbattery + '' == '1' || _data.data2[j].allowinputvoltage + '' == '1') {
                            _AllowedPKSABH = '1'
                        }
                        v._AllowedPKSABH = _AllowedPKSABH

                        v._AllowedSovozac = _data.data2[j].sovozac

                        var _AllowSTP = '1'
                        if (_that.gn.user.speed != '1' && _that.gn.user.taximeter != '1' && _that.gn.user.passengers != '1') {
                            _AllowSTP = '0'
                        }
                        v._AllowSTP = _AllowSTP

                        // console.log(v.allowfuelpulses, 'v.allowfuelpulses')
                        // console.log(_data.data2[j].allowfuelpulses, '_data.data2[j].allowfuelpulses')

                        // console.log(_data.data2[j])
                    }
                }
                if (v.visible == '1') { _visVeh = _visVeh + 1 }
                // console.log("CANBAS: "+v.alcanbas+"RPM: "+v.a_cbr);
                //console.log(v);
                //v.roomtemperature = (parseFloat(v.roomtemperature) * 100) / 100
                // console.log(v, 'daj da vidam v,')
                // _that.gn.Vehicles.push(v)
                // for (var k=0; k<_that.gn.Vehicles.length; k++){
                //     if (_that.gn.Vehicles[k].vehicleid==v.vehicleid){
                //         console.log(v.code, _that.gn.Vehicles[k].fulldt,v.fulldt)
                //         if (_that.gn.Vehicles[k].fulldt<v.fulldt){
                //             _that.gn.Vehicles[k] = v
                //             _that.moveVehicle(v.code, v.lon, v.lat)
                //         }
                //         break
                //     }
                // }
                if (currentVehicle.fulldt < v.fulldt) {
                    _that.gn.Vehicles[vehicleIndex] = v
                    for (var k = 0; k < _that.gn.VehiclesSortDt.length; k++) {
                        if (_that.gn.VehiclesSortDt[k].vehicleid == v.vehicleid) {
                            var _tmpdtzone = _that.gn.VehiclesSortDt[k].fulldt

                            if (_that.gn.VehiclesSortDt[k].zoneids + '' != v.zoneids + '') {
                                _that.gn.VehiclesSortDt[k] = v
                                //console.log(v.code + ' ' + v.fulldt + ' ' + _that.gn.VehiclesSortDt[k].zoneids + ' ' + v.zoneids)
                                _that.gn.VehiclesSortDt[k].dtzone = moment(v.fulldt)
                                _that.gn.VehiclesSortDt[k].dtzoneymd = v.fulldt
                            } else {
                                _that.gn.VehiclesSortDt[k] = v
                                _that.gn.VehiclesSortDt[k].dtzone = moment(_tmpdtzone)
                                _that.gn.VehiclesSortDt[k].dtzoneymd = _tmpdtzone
                                _that.gn.VehiclesSortDt[k].fulldt = _tmpdtzone
                            }

                            _that.gn.VehiclesSortDt.sort(_that.sortFunction);
                        }
                    }
                    _that.moveVehicle(v.code, parseFloat(v.lon), parseFloat(v.lat))
                    _that.setVehicleColor(v.code, v.color, v, 1)
                }

                //Da se proveri
                // _that.gn.VehiclesSortDt.push(v)
                // _that.gn.VehiclesSortDt[_that.gn.VehiclesSortDt.length - 1].dtzone = moment(_that.gn.VehiclesSortDt[_that.gn.VehiclesSortDt.length - 1].fulldt)
                // _that.gn.VehiclesSortDt[_that.gn.VehiclesSortDt.length - 1].dtzoneymd = _that.gn.VehiclesSortDt[_that.gn.VehiclesSortDt.length - 1].fulldt
                // _that.gn.VehiclesSortDt.sort(_that.sortFunction);
                //_that.sortVehByDt(v)
            }
            // for (var i=0; i<_data.data1.length; i++){

            // }
            // console.log(_visVeh)
            // console.log(_data.data2)
            // console.log(_that.gn.Vehicles)
            _cb()
        })

    }

    loadInitVehicles(_cb) {
        var _that = this
        // console.log(this.gn.Colors)
        this.gn._Post('/api/gn/vehiclesByRoleID/', { roleid: this.gn.user.RoleId, clientid: this.gn.user.ClientId, userid: this.gn.user.UserId, driverid: this.gn.user.driverid }, function (_data) {
            var _d = _data.data1[0].getcpforfirstws
            var arr = _d.split('#')
            var _visVeh = 0
            // console.log(_that.gn.Organisations, 'daj da vidam organizacii dali ke mi dades')
            // console.log(_data.data2, '_data.data2')
            // console.log(arr)
            for (var i = 1; i < arr.length; i++) {
                var v = _that.parseData(arr[i])
                _that.gn.VehiclesDic[v.vehicleid] = _that.gn.Vehicles.length
                for (var j = 0; j < _data.data2.length; j++) {

                    if (_data.data2[j].vehicleid + '' == v.vehicleid + '') {
                        //v.driverdest = _data.data2[j].driverdest
                        // console.log('TUKAAA')
                        // console.log(_data.data2[j])
                        // console.log(_data.data2[j].organisationid)
                        v.equipment = _data.data2[j].equipment
                        v.cancontrol = _data.data2[j].cancontrol

                        v.allowfuelpulses = _data.data2[j].allowfuelpulses
                        v.totalfuelused = _data.data2[j].totalfuelused
                        v.istank = _data.data2[j].istank
                        v.isdigalkanalogna = _data.data2[j].isdigalkanalogna
                        v.allowfuel = _data.data2[j].allowfuel
                        v.allowtacho = _data.data2[j].allowtacho
                        v.allowbeacon = _data.data2[j].allowbeacon
                        v.allowdriverfrombeacon = _data.data2[j].allowdriverfrombeacon
                        v.electric = _data.data2[j].electric
                        v.nextservicewhours = _data.data2[j].nextservicewhours
                        v.roomid = _data.data2[j].roomid
                        // console.log(v.equipment, 'v.equipment')
                        v.roaddirection = _data.data2[j].roaddirection

                        v.nopay = _data.data2[j].nopay
                        v.lastpaydt = _data.data2[j].lastpaydt == '/' ? '/' : moment(_data.data2[j].lastpaydt).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)

                        if (v.nopay == '1') {
                            v.color = 'Gray'
                            v.datumformated = v.lastpaydt
                        }

                        v.orgcolor = ''
                        v.visible = _data.data2[j].visible
                        v.organisationid = _data.data2[j].organisationid
                        v.orgname = _data.data2[j].orgname
                        v.consumptionbyhour = _data.data2[j].consumptionbyhour
                        v.brand = _data.data2[j].brand
                        v.armed = _data.data2[j].armed
                        v.multiplefueltypes = _data.data2[j].multiplefueltypes
                        //console.log('###', v.vehicleid, _data.data2[j].approve, _data.data2[j].suspend)
                        v.approve = _data.data2[j].approve
                        v.suspend = _data.data2[j].suspend

                        v.typeid = _data.data2[j].typeid
                        v.printtravelorder = _data.data2[j].printtravelorder
                        v.alias = _data.data2[j].alias
                        v.model = _data.data2[j].model
                        v.albletemp = _data.data2[j].albletemp
                        v.alrpm = _data.data2[j].alrpm
                        v.showrpm = _data.data2[j].showrpm
                        v.driver = _data.data2[j].driver
                        v.altemp = _data.data2[j].altemp
                        v.alfuel = _data.data2[j].alfuel
                        v.fuel = _data.data2[j].fuel
                        //v.ufuel = _data.data2[j].ufuel
                        v.alcanbas = _data.data2[j].alcanbas
                        v.engineworktimetype = _data.data2[j].engineworktimetype
                        // v.AllowCANbus = _data.data2[j].AllowCANbus
                        v.a_cbd = _data.data2[j].a_cbd
                        v.a_cbr = _data.data2[j].a_cbr
                        v.a_cbf = _data.data2[j].a_cbf
                        v.a_cbt = _data.data2[j].a_cbt

                        v.speedlimitalertallow = _data.data2[j].speedlimitalertallow
                        v.allowdraeger = _data.data2[j].allowdraeger

                        v.dashboard = false
                        //debugger

                        v.slot1name = _data.data2[j].slot1name
                        v.a_bletemp1 = _data.data2[j].allowbletemp1
                        v.a_blehumidity1 = _data.data2[j].allowblehumidity1
                        v.a_blebattery1 = _data.data2[j].allowblebattery1

                        v.slot2name = _data.data2[j].slot2name
                        v.a_bletemp2 = _data.data2[j].allowbletemp2
                        v.a_blehumidity2 = _data.data2[j].allowblehumidity2
                        v.a_blebattery2 = _data.data2[j].allowblebattery2

                        v.slot3name = _data.data2[j].slot3name
                        v.a_bletemp3 = _data.data2[j].allowbletemp3
                        v.a_blehumidity3 = _data.data2[j].allowblehumidity3
                        v.a_blebattery3 = _data.data2[j].allowblebattery3

                        v.slot4name = _data.data2[j].slot4name
                        v.a_bletemp4 = _data.data2[j].allowbletemp4
                        v.a_blehumidity4 = _data.data2[j].allowblehumidity4
                        v.a_blebattery4 = _data.data2[j].allowblebattery4

                        v.allowbattery = _data.data2[j].allowbattery
                        v.allowultrasonic = _data.data2[j].allowultrasonic
                        v.zonenames = _data.data2[j].zonenames
                        v.poinames = _data.data2[j].poinames
                        v.allowgarmin = _data.data2[j].allowgarmin
                        v.allowengineblock = _data.data2[j].allowengineblock

                        v.stopstatusdata = []

                        var _AllowedPKSABH = '0'
                        if (_data.data2[j].prednavrata != '-' || _data.data2[j].zadnavrata != '-' || _data.data2[j].hauba != '-' || _data.data2[j].kapaci != '-' || _data.data2[j].pumpa != '-' || _data.data2[j].sovozac != '-' || _data.data2[j].digalka != '-' || _data.data2[j].allowbattery + '' == '1' || _data.data2[j].allowinputvoltage + '' == '1') {
                            _AllowedPKSABH = '1'
                        }
                        v._AllowedPKSABH = _AllowedPKSABH

                        v._AllowedSovozac = _data.data2[j].sovozac

                        var _AllowSTP = '1'
                        if (_that.gn.user.speed != '1' && _that.gn.user.taximeter != '1' && _that.gn.user.passengers != '1') {
                            _AllowSTP = '0'
                        }
                        v._AllowSTP = _AllowSTP

                        // console.log(v.allowfuelpulses, 'v.allowfuelpulses')
                        // console.log(_data.data2[j].allowfuelpulses, '_data.data2[j].allowfuelpulses')

                        // console.log(_data.data2[j])
                    }
                }
                if (v.visible == '1') { _visVeh = _visVeh + 1 }
                // console.log("CANBAS: "+v.alcanbas+"RPM: "+v.a_cbr);
                //console.log(v);
                //v.roomtemperature = (parseFloat(v.roomtemperature) * 100) / 100
                // console.log(v, 'daj da vidam v,')
                _that.gn.Vehicles.push(v)


                //debugger
                // console.log('#' + _that.gn.Vehicles.length)
                _that.gn.VehiclesSortDt.push(v)
                _that.gn.VehiclesSortDt[_that.gn.VehiclesSortDt.length - 1].dtzone = moment(_that.gn.VehiclesSortDt[_that.gn.VehiclesSortDt.length - 1].fulldt)
                _that.gn.VehiclesSortDt[_that.gn.VehiclesSortDt.length - 1].dtzoneymd = _that.gn.VehiclesSortDt[_that.gn.VehiclesSortDt.length - 1].fulldt
                _that.gn.VehiclesSortDt.sort(_that.sortFunction);
                //_that.sortVehByDt(v)
            }
            // for (var i=0; i<_data.data1.length; i++){

            // }
            // console.log(_visVeh)
            // console.log(_data.data2)
            // console.log(_that.gn.Vehicles)
            _cb()
        })

    }

    sortFunction(a, b) {
        var dateA = new Date(a.dtzone).getTime();
        var dateB = new Date(b.dtzone).getTime();
        return dateA > dateB ? 1 : -1;
    };

    parseData(_data) {
        var dat = _data.split('|')
        //console.log(dat[0] + ' ' + dat[67])
        //console.log('parseData: ' + dat.length)
        if (dat.length < 30) {
            return
        }

        // if (dat[27] == 6197) {
        //     console.log('###')
        //     console.log(dat)
        // }
        var _weather = []
        if (dat[41].indexOf('@@@') > -1) {
            // _weather = dat[41].split('@@@')
            var _tmpWth = dat[41].split('@@@')
            if (_tmpWth.length == 7) {
                _tmpWth[5] = _tmpWth[5].replace('https://openweathermap.org/img/wn/', 'https://panorama.gps.mk/wicons/')
                _weather = _tmpWth
            }

        }

        var Vehicle = {
            code: dat[0],
            lon: dat[1],
            lat: dat[2],
            _status: dat[3],
            passive: dat[4],
            datum: dat[5],
            datumformated: '',
            location: dat[6],
            taxi: dat[8],
            sedista: dat[9],
            olddate: dat[10],
            olddate15: dat[45],
            portai4: (dat[93] != 'undefined' && dat[93] != undefined && dat[93] != null && dat[93] != '') ? dat[93] : 0,
            engineworktime: (dat[94] != 'undefined' && dat[94] != undefined && dat[94] != null && dat[94] != '') ? dat[94] : 0,
            engineworktimemanual: (dat[95] != 'undefined' && dat[95] != undefined && dat[95] != null && dat[95] != '') ? this.sec2str2(dat[95] * 3600) : 0,
            address: dat[11],
            gis: dat[12],
            registration: dat[13],
            alarm: dat[14],
            fulldt: dat[15],
            cbfuel: dat[16],
            cbrpm: dat[17],
            cbtemp: dat[18],
            cbdistance: dat[19],
            temperature: dat[20],
            roomtemperature: (parseFloat(dat[56]) * 100) / 100,
            litres: dat[21],
            ufuel: dat[39],
            zoneids: dat[22],
            odometar: dat[23],
            service: dat[24],
            status: dat[25],
            zonedt: dat[26],
            vehicleid: dat[27],
            ignition: dat[28],
            kapaci: dat[29],
            pumpa: dat[30],
            rpm: dat[31],
            driver: dat[32],
            sopatnik: dat[33],
            gsmnum: dat[34],
            engineblock: dat[35],
            doorstatus: dat[102],//can control
            enginestatus: dat[103],//can control
            battery: dat[36],
            inputvoltage: dat[38] == '-2' ? this.dic.l["fAccumulator"] : (dat[38].indexOf('-1:::') != '-1' ? ('' + this.dic.l["weakAccumulator"] + ' (' + parseFloat(dat[38].split(':::')[1]).toFixed(2) + ' V)') : (dat[38] == '/' ? dat[38] : parseFloat(dat[38]).toFixed(2) + ' V')),
            ultrasonic: dat[39],
            digalka: dat[40],

            prednavrata: (dat[58] != undefined) ? parseInt(dat[58]) : -1,
            zadnavrata: (dat[59] != undefined) ? parseInt(dat[59]) : -1,
            hauba: (dat[67] != undefined) ? parseInt(dat[67]) : -1,

            fuelpulses: dat[69] == -1 ? -1 : parseFloat(dat[69]),
            fuelpulsesveh: dat[96],
            saldo: dat[97],

            lastgeneratordata: dat[98],
            lastgeneratordata1: '',
            lastgeneratordata2: '',
            lastgeneratordata3: (dat[98] != 'undefined' && dat[98] != undefined && dat[98] != null && dat[98] != '') ? (parseFloat(dat[98].split('~')[2]) <= 0 ? '/' : dat[98].split('~')[2]) : '/',

            generatorengine: dat[65],
            generatornextservice: dat[99],

            idlestatusminutes: (dat[105] != 'undefined' && dat[105] != undefined && dat[105] != null && dat[105] != '') ? dat[105] : 0,

            lastdraegerdata_date: (dat[110] != 'undefined' && dat[110] != undefined && dat[110] != null && dat[110] != 'null' && dat[110] != '/') ? moment(dat[110].split('&&&')[0]).format(this.gn.user.DFormat) : '/',
            lastdraegerdata_time: (dat[110] != 'undefined' && dat[110] != undefined && dat[110] != null && dat[110] != 'null' && dat[110] != '/') ? moment(dat[110].split('&&&')[0]).format(this.gn.user.TFormat) : '/',
            lastdraegerdata_val: (dat[110] != 'undefined' && dat[110] != undefined && dat[110] != null && dat[110] != 'null' && dat[110] != '/') ? parseFloat(dat[110].split('&&&')[1]).toFixed(3) : 0,

            digalkaanalog: (dat[100] != 'undefined' && dat[100] != undefined && dat[100] != null && dat[100] != '') ? dat[100] : '0',

            //ocena live
            // dscore: '/',
            // nscore: '/',
            // mscore: '/',
            dscore: (dat[101] != 'undefined' && dat[101] != undefined && dat[101] != null && dat[101] != '') ? dat[101].split('^')[0] : '/',
            nscore: (dat[101] != 'undefined' && dat[101] != undefined && dat[101] != null && dat[101] != '') ? dat[101].split('^')[1] : '/',
            mscore: (dat[101] != 'undefined' && dat[101] != undefined && dat[101] != null && dat[101] != '') ? dat[101].split('^')[2] : '/',
            // didscore: (dat[101] != 'undefined' && dat[101] != undefined && dat[101] != null && dat[101] != '') ? dat[101].split('^')[3] : '/',
            // //end ocena live

            //bletemp1: (parseFloat(dat[71]) * 100) / 100,
            bletemp1: (dat[71] != '//' && dat[71] != 'undefined' && dat[71] != undefined && dat[71] != null && dat[71] != '') ? (((parseFloat(dat[71]) * 100) / 100) + ` °` + this.gn.user.tempunit) : '/',
            bletemp2: (dat[79] != '//' && dat[79] != 'undefined' && dat[79] != undefined && dat[79] != null && dat[79] != '') ? (((parseFloat(dat[79]) * 100) / 100) + ` °` + this.gn.user.tempunit) : '/',
            bletemp3: (dat[80] != '//' && dat[80] != 'undefined' && dat[80] != undefined && dat[80] != null && dat[80] != '') ? (((parseFloat(dat[80]) * 100) / 100) + ` °` + this.gn.user.tempunit) : '/',
            bletemp4: (dat[81] != '//' && dat[81] != 'undefined' && dat[81] != undefined && dat[81] != null && dat[81] != '') ? (((parseFloat(dat[81]) * 100) / 100) + ` °` + this.gn.user.tempunit) : '/',
            blehumidity1: (dat[82] != '//' && dat[82] != 'undefined' && dat[82] != undefined && dat[82] != null && dat[82] != '') ? (((parseFloat(dat[82]) * 100) / 100) + ' %') : '/',
            blehumidity2: (dat[83] != '//' && dat[83] != 'undefined' && dat[83] != undefined && dat[83] != null && dat[83] != '') ? (((parseFloat(dat[83]) * 100) / 100) + ' %') : '/',
            blehumidity3: (dat[84] != '//' && dat[84] != 'undefined' && dat[84] != undefined && dat[84] != null && dat[84] != '') ? (((parseFloat(dat[84]) * 100) / 100) + ' %') : '/',
            blehumidity4: (dat[85] != '//' && dat[85] != 'undefined' && dat[85] != undefined && dat[85] != null && dat[85] != '') ? (((parseFloat(dat[85]) * 100) / 100) + ' %') : '/',

            towstatus: (dat[86] != undefined) ? parseInt(dat[86]) : -1,
            lastbeacon: (dat[87] != undefined && dat[87] != null && dat[87] != '') ? (dat[87]).split('~')[2] : '/',
            ekipa: (dat[88] != undefined && dat[88] != null && dat[88] != '') ? dat[88] : '/',

            batcharging: (dat[89] != 'undefined' && dat[89] != undefined && dat[89] != null && dat[89] != '') ? dat[89] : '0',
            chargingcable: (dat[90] != 'undefined' && dat[90] != undefined && dat[90] != null && dat[90] != '') ? dat[90] : '0',
            electricbat: (dat[91] != 'undefined' && dat[91] != undefined && dat[91] != null && dat[91] != '') ? dat[91] : '0',

            portdi2: (dat[92] != 'undefined' && dat[92] != undefined && dat[92] != null && dat[92] != '') ? dat[92] : '0',

            routedetails: (dat[72] != undefined) ? dat[72] : '-1',
            mixerstatus: (dat[73] != '' && dat[73] != undefined) ? dat[73].replace(/ /g, '').substring(0, 1) : '/',

            frontr: (dat[74] != undefined) ? parseInt(dat[74]) : -1,
            frontl: (dat[75] != undefined) ? parseInt(dat[75]) : -1,
            stranichna: (dat[76] != undefined) ? ((parseFloat(dat[76]) != -1) ? (parseFloat(dat[76]) > 12 ? 1 : 0) : -1) : -1,

            d1timerelstate: (dat[77] != undefined) ? parseFloat(dat[77]) : -1,
            d2timerelstate: (dat[78] != undefined) ? parseFloat(dat[78]) : -1,

            lostcomm: 0,
            lostcomm15: 0,
            weather: _weather,
            speedNumber: 0,
            speed: '', sofer: '', leftdoor: '', rightdoor: '', overside: '', reardoor: '',
            driverdest: '', endlocation: '/', statusign: dat[28], roaddirection: '', nopay: '0', lastpaydt: '/', geolock: '', radius: '',
            noconnection: false, noconnection15: true, color: '', visible: '0', tmpVisible: true,
            orgcolor: '',
            organisationid: 0,
            orgname: this.dic.l["Ungroupped"],
            consumptionbyhour: '0',
            brand: '',
            armed: '0',

            multiplefueltypes: '0',
            approve: 2,
            suspend: '1',

            typeid: 1,
            printtravelorder: '',
            alias: '', model: '', albletemp: 0, alrpm: 0, showrpm: '', altemp: 0, alfuel: 0, fuel: 0.0, allowultrasonic: 0, /*ufuel: 0.00,*/
            alcanbas: 0, engineworktimetype: '', AllowCANbus: 0, a_cbd: 0, a_cbr: 0, a_cbf: 0, a_cbt: 0, speedlimitalertallow: 0, allowdraeger: 0, dashboard: false, slot1name: this.dic.l["slot"] + '1', a_bletemp1: 0, a_blehumidity1: 0, a_blebattery1: 0, slot2name: this.dic.l["slot"] + '2', a_bletemp2: 0, a_blehumidity2: 0, a_blebattery2: 0, slot3name: this.dic.l["slot"] + '3', a_bletemp3: 0, a_blehumidity3: 0, a_blebattery3: 0, slot4name: this.dic.l["slot"] + '4', a_bletemp4: 0, a_blehumidity4: 0, a_blebattery4: 0, _AllowedPKSABH: '0', allowbattery: 0, _AllowSTP: '0', zonenames: dat[11], poinames: '',
            searchVisible: true,
            vehtype: dat[68], _AllowedSovozac: '-',
            ismachine: dat[70],
            allowfuelpulses: '0',
            totalfuelused: '0',
            istank: '0',
            isdigalkanalogna: '0',
            allowfuel: '0',
            allowtacho: '0',
            allowbeacon: '0',
            allowdriverfrombeacon: '0',
            electric: '0',
            nextservicewhours: 0,
            roomid: -1,
            equipment: '',
            cancontrol: '',
            allowgarmin: '0',
            allowengineblock: '0',
            stopstatusdata: []
            //,col5: dat[69] == undefined ? -1 : dat[69]
        }
        //console.log(Vehicle.datum)

        if (this.gn.isNumeric(Vehicle.cbrpm)) {
            Vehicle.cbrpm = parseInt(Vehicle.cbrpm)
            if (Vehicle.ignition + '' == '0') {
                Vehicle.cbrpm = 0
            }
        }

        if (this.gn.isNumeric(Vehicle.cbtemp)) {
            Vehicle.cbtemp = parseInt(Vehicle.cbtemp)
            if (Vehicle.ignition + '' == '0') {
                Vehicle.cbtemp = 0
            }
        }

        if (this.gn.isNumeric(Vehicle.cbfuel)) {
            Vehicle.cbfuel = parseInt(Vehicle.cbfuel)
            // if (Vehicle.ignition+''=='0'){
            //     Vehicle.cbrpm = 0
            // }
        }
        //cbfuel

        //Vehicle.datumformated = driveruser(Vehicle.datum, "DD-MM-YYYY HH:mm:ss").format(this.gn.user.DFormat) + ' ' + moment(Vehicle.datum, "DD-MM-YYYY HH:mm:ss").format(this.gn.user.TFormat)
        Vehicle.datumformated = moment(Vehicle.fulldt).format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat)

        if (Vehicle.lastgeneratordata != 'undefined' && Vehicle.lastgeneratordata != undefined && Vehicle.lastgeneratordata != null && Vehicle.lastgeneratordata != '') {
            Vehicle.lastgeneratordata1 = Vehicle.lastgeneratordata == '' ? '/' : moment(Vehicle.lastgeneratordata.split('~')[0]).format(this.gn.user.DFormat + ' ' + this.gn.user.TFormat)
            Vehicle.lastgeneratordata2 = Vehicle.lastgeneratordata == '' ? '/' : this.sec2str2(Vehicle.lastgeneratordata.split('~')[1])
        }

        if (Vehicle.ignition == '1') Vehicle.statusign = '2';
        if (Vehicle.ignition == '1' && Vehicle.idlestatusminutes > this.gn.user.idleover) Vehicle.statusign = '1';

        // console.log(dat[7])
        Vehicle.speedNumber = dat[7]
        if (dat[7] == '/' || dat[7] == '') {
            Vehicle.speed = '/'
        } else {
            Vehicle.speed = parseInt(dat[7], 10) + ' Km/h';
        }
        if (this.gn.user.metric.toLowerCase() != 'km') {
            Vehicle.speed = Vehicle.speed == '/' ? Vehicle.speed : Math.round(Math.round((parseFloat(dat[7]) * 0.621371) * 100) / 100) + ' mph';
            Vehicle.odometar = Math.round(dat[23] * 0.621371);
            Vehicle.service = Math.round(dat[24] * 0.621371);
            Vehicle.cbdistance = Math.round(dat[19] * 0.621371);

        }
        if (dat[60] == '-1' || dat[60] == undefined) {
            Vehicle.sofer = '/'
        } else {
            if (dat[60] == '1') {
                Vehicle.sofer = 'sit';
            } else {
                Vehicle.sofer = 'stand';
            }
        }

        if (parseInt(dat[58], 10) == -1 || dat[58] == undefined || parseInt(dat[58], 10) == 0) {
            Vehicle.leftdoor = '/';
            Vehicle.rightdoor = '/';
        } else
            if (parseFloat(dat[58]) <= 9.7) {
                Vehicle.leftdoor = 'open';
                Vehicle.rightdoor = 'open';
            } else
                if (parseFloat(dat[58]) > 9.7 && parseFloat(dat[58]) <= 14.5) {
                    Vehicle.leftdoor = 'close';
                    Vehicle.rightdoor = 'open';
                } else
                    if (parseFloat(dat[58]) > 14.5 && parseFloat(dat[58]) <= 20) {
                        Vehicle.leftdoor = 'open';
                        Vehicle.rightdoor = 'close';
                    } else
                        if (parseFloat(dat[58]) > 20) {
                            Vehicle.leftdoor = 'close';
                            Vehicle.rightdoor = 'close';
                        }

        if (parseInt(dat[59], 10) == -1 || dat[59] == undefined || parseInt(dat[59], 10) == 0) {
            Vehicle.overside = '/';
            Vehicle.reardoor = '/';
        } else
            if (parseFloat(dat[59]) <= 11.5) {
                Vehicle.overside = 'open';
                Vehicle.reardoor = 'open';
            } else
                if (parseFloat(dat[59]) > 11.5 && parseFloat(dat[59]) <= 15) {
                    Vehicle.overside = 'close';
                    Vehicle.reardoor = 'open';
                } else
                    if (parseFloat(dat[59]) > 15 && parseFloat(dat[59]) <= 20) {
                        Vehicle.overside = 'open';
                        Vehicle.reardoor = 'close';
                    } else
                        if (parseFloat(dat[59]) > 20) {
                            Vehicle.overside = 'close';
                            Vehicle.reardoor = 'close';
                        }

        Vehicle.driverdest = dat[42];
        if (Vehicle.driverdest != '/') {
            Vehicle.driverdest = Vehicle.driverdest.split('@')[0]
            if (Vehicle.driverdest == '') {
                Vehicle.driverdest = Vehicle.driverdest.split('@')[1] + ', ' + Vehicle.driverdest.split('@')[2]
            }
        }

        //START EndLocation
        if (Vehicle.routedetails != '-1' && Vehicle.routedetails.split('@')[0] + '' == '1') {
            var rr = Vehicle.routedetails.split('@')[1].split('/')

            var nextpoi = '/'
            if (rr[0] != rr[1] || rr[0] + '' == '0') {
                nextpoi = Vehicle.routedetails.split('@')[2]
            }
            Vehicle.endlocation = nextpoi;
        }
        if (Vehicle.driverdest != '/') {
            if (Vehicle.endlocation != '/') {
                Vehicle.endlocation += '; ' + Vehicle.driverdest;
            } else {
                Vehicle.endlocation = Vehicle.driverdest;
            }
        }
        //END EndLocation

        // var tmpa = dat[37]
        // if (tmpa==null){tmpa='0'}
        // if (dat[37] == "0") {
        //     Vehicle.geolock = "0";
        //     Vehicle.radius = "0";
        // } else {
        //     Vehicle.geolock = dat[37].split("-")[0];
        //     Vehicle.radius = dat[37].split("-")[1];
        // }
        //console.log(Vehicle)
        if (Vehicle.ignition == '1' && Vehicle.olddate == '1')
            Vehicle.noconnection = true;
        else
            Vehicle.noconnection = false;

        if (this.gn.clientsettings.indoor > 0) {
            if (Vehicle.olddate == '1')
                Vehicle.noconnection = true;
            else
                Vehicle.noconnection = false;
        }
        if (Vehicle.ignition == '1' && Vehicle.olddate15 == '1')
            Vehicle.noconnection15 = true;
        else
            Vehicle.noconnection15 = false;

        if (this.gn.clientsettings.indoor > 0) {
            if (Vehicle.olddate15 == '1')
                Vehicle.noconnection15 = true;
            else
                Vehicle.noconnection15 = false;
        }
        Vehicle.color = 'Gray'
        var _sedista = 0

        if (this.gn.isNumeric(Vehicle.sedista)) {
            _sedista = parseInt(Vehicle.sedista)
        }
        if (Vehicle.ignition == '0' && _sedista == 0) {
            Vehicle.color = this.gn.Colors.engineoff
        }
        if (Vehicle.ignition == '0' && _sedista > 0) {
            Vehicle.color = this.gn.Colors.engineoffpassengeron
        }
        if (Vehicle.ignition == '1' && _sedista > 0 && Vehicle.taxi == '0') {
            Vehicle.color = this.gn.Colors.taximeteroffpassengeron
        }
        if (Vehicle.ignition == '1' && Vehicle.taxi == '1') {
            Vehicle.color = this.gn.Colors.taximeteron
        }
        if (Vehicle.ignition == '1' && _sedista == 0 && Vehicle.taxi == '0') {
            Vehicle.color = this.gn.Colors.engineon
        }
        if (Vehicle.passive == '1') {
            Vehicle.color = this.gn.Colors.passiveon
        }
        if (Vehicle.ignition == '1' && Vehicle.olddate == '1') {
            Vehicle.color = 'Gray'
            //todo
            Vehicle.lostcomm = 1
        } else {
            //todo
            Vehicle.lostcomm = 0
        }
        if (this.gn.clientsettings.indoor > 0) {
            if (Vehicle.olddate == '1') {
                Vehicle.color = 'Gray'
                //todo
                Vehicle.lostcomm = 1
            } else {
                //todo
                Vehicle.lostcomm = 0
            }
        }

        if (Vehicle.nopay == '1') {
            Vehicle.color = 'Gray'
            Vehicle.datumformated = Vehicle.lastpaydt
        }

        if (Vehicle.ignition == '1' && Vehicle.olddate15 == '1') {
            Vehicle.lostcomm15 = 1
        } else {
            Vehicle.lostcomm15 = 0
        }
        if (this.gn.clientsettings.indoor > 0) {
            if (Vehicle.olddate15 == '1') {
                Vehicle.lostcomm15 = 1
            } else {
                Vehicle.lostcomm15 = 0
            }
        }
        // console.log(Vehicle, 'daj da vidam vehicle')
        return Vehicle
    }

    distance(x1, y1, x2, y2) {
        var length = 0;
        var wgs84Sphere = new ol.Sphere(6378137);
        length += wgs84Sphere.haversineDistance([x1, y1], [x2, y2]);
        // console.log(length)
        return length;
    }

    sec2str2(_sec) {
        if (_sec >= 0) {
            var str = '';
            var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
            var m = moment.utc(_sec * 1000).format('m');
            var s = moment.utc(_sec * 1000).format('s');
            if (_sec < 60) {
                str = s + this.dic.l["sec"];
            }
            else {
                if (_sec < 3600) {
                    str = m + this.dic.l["min"]
                }
                else {
                    str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
                }
            }
            return str;
        }
        else {
            return '-1';
        }
    }


    moveVehicle(_code, _lon, _lat) {
        if (this.gn.mapPage == null) { return }
        for (var i = 0; i < this.gn.VehicleAnim.length; i++) {
            var m = this.gn.VehicleAnim[i]
            if (m.code == _code) {

                //ako e otvoren dole prozorot za dashboard da ne go mrda voziloto na nov podatok
                //if (this.gn.Vehicles[i].dashboard) { return false }

                // for (var j = 0; j < this.gn.VehicleAnim[i].anim.length; j++) {
                //     clearTimeout(this.gn.VehicleAnim[i].anim[j]);
                // }
                var duration = 2000.0
                var speed = 10.0
                var dX = (_lon - m.lon) / speed
                var dY = (_lat - m.lat) / speed
                var dT = duration / speed
                var tim = dT

                var p1 = ol.proj.transform([this.gn.VehicleAnim[i].lon, this.gn.VehicleAnim[i].lat], 'EPSG:4326', 'EPSG:900913')
                var p2 = ol.proj.transform([_lon, _lat], 'EPSG:4326', 'EPSG:900913')

                var ddX = p2[0] - p1[0];
                var ddY = p2[1] - p1[1];
                var alfa = Math.round(Math.atan2(ddY * 1.0, ddX * 1.0) * (180.0 / Math.PI));
                alfa = 0 - alfa

                var topka = document.getElementById('gncar-' + _code)
                // console.log(topka)

                if (topka != null) {
                    topka.setAttribute('angle', "yes")
                    var elnose = <HTMLElement>topka.getElementsByClassName('gn-nouse' + this.gn.user.vehsize)[0]
                    elnose.style.transform = 'rotate(' + alfa + 'deg)'
                }
                var _that = this
                var distance = this.distance(m.lon, m.lat, _lon, _lat)
                if (distance > 500) {
                    _that.gn.mapPage.moveMarker2(i, _lon, _lat, _code, alfa)
                } else {
                    for (var j = 0; j < speed; j++) {
                        tim = tim + dT
                        if (this.gn.VehicleAnim[i].anim.length > 30)
                            this.gn.VehicleAnim[i].anim = []
                        this.gn.VehicleAnim[i].anim.push({ angle: alfa, lon: (m.lon + (dX * j)), lat: (m.lat + (dY * j)) })

                        //console.log('Anim length: ' + _code + ' ' + this.gn.VehicleAnim[i].anim.length)
                    }
                }
                this.gn.VehicleAnim[i].lon = _lon
                this.gn.VehicleAnim[i].lat = _lat
                break;
            }
        }
    }

    // <div class="veh-reg-cl gn-car-' + v.color + '" style="display:none; white-space: nowrap; height:16px; line-height:0px; border-radius: 2px; width: auto; position: relative !important; top: 2px !important; padding-top: 7px !important; margin-top:4px !important; /">
    // el.innerHTML = '<span style="z-index:1; position: relative; word-wrap:normal">' + v.code + '</span><div class="veh-reg-cl1 bottom-arrow arrow-' + v.color + '" style="display:none"></div><div class="veh-reg-cl gn-car-' + v.color + '" style="display:none; white-space: nowrap; height:16px; line-height:0px; border-radius: 2px; width: auto; position: relative !important; top: 2px !important; padding-top: 7px !important; margin-top:4px !important; /">' + v.registration + '</div>'

    setVehicleColor(_code, _color, _veh, _tf) {
        //console.log('setVehicleColor: ' + _code + ' ' + _color)
        //v.vehicleid
        var obj = document.getElementById('gncar-' + _code)
        if (obj == null && _tf == 0)
            obj = document.getElementById('gncar-rec-' + _code)

        if (obj != null) {
            var _objclassname = ''
            if (obj.className.indexOf('gn-ol-market' + this.gn.user.vehsize + '-anim') > -1) {
                _objclassname = "gn-ol-market" + this.gn.user.vehsize + " gn-ol-market" + this.gn.user.vehsize + "-anim gn-car-" + _color
            } else {
                _objclassname = "gn-ol-market" + this.gn.user.vehsize + " gn-car-" + _color
            }
            //pulse class na follow vozila
            var selFollVeh = this.gn.getCookie("selfollvehids");
            var selFollVehIDs = JSON.parse("[" + selFollVeh + "]")
            if (selFollVeh != '' && (selFollVeh.indexOf(_veh.vehicleid) != -1)) {
                _objclassname += " pulseV"
            }
            obj.className = _objclassname;

            if (_veh.orgcolor != '')
                obj.style.border = "5px solid " + _veh.orgcolor
            obj.style.boxSizing = "content-box"
            obj.style.boxShadow = "0px 0px 10px #000"
            //debugger;
            if (document.getElementById('gncarimg01-' + _code) != undefined) {
                var _dimg01 = 'none';
                var _dimg02 = 'none';
                var _dimg03 = 'none';
                if ((_veh.lostcomm + '' == '1' || _veh.lostcomm15 + '' == '1') && _veh.status + '' == '1') {
                    _dimg01 = 'block';
                }
                if (_veh.status + '' == '0' && _veh.lostcomm + '' == '0' && _veh.lostcomm15 + '' == '0') {
                    _dimg02 = 'block';
                }
                if ((_veh.lostcomm + '' == '1' || _veh.lostcomm15 + '' == '1') && _veh.status + '' == '0') {
                    _dimg03 = 'block';
                }
                document.getElementById('gncarimg01-' + _code).style.display = _dimg01;
                document.getElementById('gncarimg02-' + _code).style.display = _dimg02;
                document.getElementById('gncarimg03-' + _code).style.display = _dimg03;
            }

            var registration = obj.children[2]
            if (registration != undefined) {
                if (registration.className != undefined) {
                    if (registration.className.indexOf('veh-reg-cl') > -1) {
                        obj.children[2].className = 'veh-reg-cl gn-car-' + _color + ''
                        // obj.children[2].className = '<div class="veh-reg-cl gn-car-' + _color + '" style="display:none; white-space: nowrap; height:16px; line-height:0px; border-radius: 2px; width: auto; position: relative !important; top: 2px !important; padding-top: 7px !important; margin-top:4px !important; /"></div>'
                    }
                }
            }

            var registrationarrow = obj.children[1]
            if (registrationarrow != undefined) {
                if (registrationarrow.className != undefined) {
                    if (registrationarrow.className.indexOf('veh-reg-cl1') > -1) {
                        obj.children[1].className = 'veh-reg-cl1 bottom-arrow arrow-' + _color + ''
                        // obj.children[1].className = '<div class="veh-reg-cl1 bottom-arrow arrow-' + _color + '" style="display:none"></div>'
                    }
                }
            }

            var vehinfo = obj.children[3]
            if (vehinfo != undefined) {
                if (vehinfo.className != undefined) {
                    if (vehinfo.className.indexOf('veh-info-cl') > -1) {
                        obj.children[3].className = 'veh-info-cl gn-car-' + _color + ''
                    }
                }
            }

            if (this.gn.mapPage != undefined) {
                if (selFollVeh != '') {
                    if (this.gn.mapPage.MapType == 'GOOGLE') {
                        var bounds = new google.maps.LatLngBounds();
                        //var extend = false;
                        var mi = 0;
                        for (var k = 0; k < this.gn.Markers.length; k++) {
                            for (var j = 0; j < selFollVehIDs.length; j++) {
                                if (this.gn.Markers[k].i + '' == this.gn.VehiclesDic[selFollVehIDs[j]] + '') {
                                    bounds.extend(this.gn.Markers[k].position);
                                    mi++;
                                    //if (!(this.gn.mapPage.Map).getBounds().contains((this.gn.Markers[k]).getPosition())) {
                                    //    extend = true;
                                    //}
                                }
                            }
                        }
                        //if (extend)
                        if (mi > 0) {
                            //this.gn.mapPage.Map.fitBounds(bounds, { top: -200, paddingLeft: 60, paddingRight: 60 });
                            this.gn.mapPage.Map.fitBounds(bounds);
                        }

                        if (this.gn.mapPage.Map.getZoom() > 16) {
                            this.gn.mapPage.Map.setZoom(16);
                        }
                    } else {
                        var lat_min = 41.998207; var lat_max = 41.998207; var lng_min = 21.426381; var lng_max = 21.426381;
                        var mi = 0;
                        for (var k = 0; k < this.gn.Markers.length; k++) {
                            for (var j = 0; j < selFollVehIDs.length; j++) {
                                if (this.gn.Markers[k].getElement().getAttribute('iattr') + '' == this.gn.VehiclesDic[selFollVehIDs[j]] + '') {
                                    var ll = this.gn.Markers[k].getPosition()
                                    var _lon = ll[0]
                                    var _lat = ll[1]
                                    if (mi == 0) {
                                        lat_min = _lat
                                        lat_max = _lat
                                        lng_min = _lon
                                        lng_max = _lon
                                    } else {
                                        if (_lat < lat_min) { lat_min = _lat }
                                        if (_lat > lat_max) { lat_max = _lat }
                                        if (_lon < lng_min) { lng_min = _lon }
                                        if (_lon > lng_max) { lng_max = _lon }
                                    }
                                    mi++;
                                }
                            }
                        }
                        if (mi > 0) {
                            var ext = [lng_min, lat_min, lng_max, lat_max]
                            this.gn.mapPage.Map.getView().fit(ext, this.gn.mapPage.Map.getSize())
                        }
                        if (this.gn.mapPage.Map.getView().getZoom() > 16) {
                            this.gn.mapPage.Map.getView().setZoom(16);
                        }
                    }
                }
            }
        }
    }

    // centerToVehcile(_code){
    //     var ll = this.gn.mapPage.getVehiclePosition(_code)
    //     console.log(ll)
    //     // if (ll.lon!=0){
    //     //     this.gn.mapPage.maps.setCenter(ll.lon, ll.lat)
    //     //     this.gn.mapPage.maps.setZoom(16)
    //     //     $('.gn-ol-market[car-code="'+_code+'"]').addClass('gn-ol-market-anim')
    //     //     $('.gn-ol-market[car-code="'+_code+'"]').css({zIndex: 3})
    //     //     var _el = $('.gn-vehicle-details [gn-vh-card-code="'+_code+'"]')
    //     //     if (_el.length>0){
    //     //         var _top = _el.offset().top
    //     //         $('.gn-menu-left').scrollTop(_top-80)
    //     //         _el.addClass('gn-car-card-animate')
    //     //         setTimeout("$('.gn-vehicle-details [gn-vh-card-code=\""+_code+"\"]').removeClass('gn-car-card-animate')", 8000)
    //     //     }
    //     //     setTimeout("$('.gn-ol-market[car-code=\""+_code+"\"]').removeClass('gn-ol-market-anim').css({zIndex: ''})", 8000)
    //     // }
    // }
}



// WEBPACK FOOTER //
// ./src/vehicles.ts